import { ArgsType } from '@nestjs/graphql'
import { BaseDeleteDto } from '../base/baseDelete.dto'

@ArgsType()
export class DeleteUserDto extends BaseDeleteDto<DeleteUserDto> { }
